import React from 'react';

/**
 * `젤리 `체크
 * each <optional>
 * each.field : 체크박스를 배열로 넣어서 쓸때 각 체크박스 요소. [ {field:true}, {field:false}, {field:true}... ] 이런식의 구조
 * */

function JellyCheckBox({title, checked, fnc, className}) {
    return (
        <div className={`line-height-30  ${className}` }>
            <label className="checkbox-jelly">
                <input
                    type={"checkbox"}
                    onChange={fnc}
                    checked={checked}
                />
                <span className={"icon"}></span>
                {title &&
                    <span className={"chk-title"}>{title}</span>
                }
            </label>
        </div>
    );
}

export default JellyCheckBox;